<template>
  <footer :class="$store.state.common.theme !=3 ?'footer' :'footer footer_3'">
      <p :class="[canClick?'canclick':'',$store.state.common.theme !=3 ? '':'canclick_color']" @click.stop="btnClick">{{text}}</p>
  </footer>
</template>

<script>
export default {
  name: 'commonFooter',
  props: {
    text:{
      type:String,
      default:'下一步'
    },
    canClick:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    btnClick(){
      if(!this.canClick){
        return;
      }
      this.$emit("btnClick")
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.footer {
  position: fixed;
  bottom:0;left:0;right:0;
  z-index:333;
  background:#fff;
  height:108px;
  width:100%;
  
  p{
    display: block;
    margin:16px 28px;
    height:76px;
    line-height:76px;
    text-align:center;
    background:#dadada;
    border-radius: 4px;
    color:#fff;
    font-size:32px;
    &.canclick{
      background:#1740DA;
    }
    &.canclick_color{
      background: #A1805D;
      border-radius: 60px;
    }
  }
}
.footer_3{
  box-shadow: 0 0px 10px rgba(0, 0, 0, 1);
}
</style>
